module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-3-a052ca4803833fc00650999fd1448631.png";